export default "__VITE_ASSET__ClV7mrQI__"